import { useState } from "react";
import { Navbar, Container, Nav } from "react-bootstrap";
import "./index.css";
import logo from "../../ASSETS/KUR DIAG HORIZ.svg";

const NavBar = () => {
  return (
    <Navbar expand="lg" className="custom-navbar">
      <Container fluid>
        {/* LOGO */}
        <Navbar.Brand href="/">
          <img
            src={logo}
            alt="KUR Diagnostics Logo"
            className="navbar-logo"
          />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="navbar-nav" />

        <Navbar.Collapse id="navbar-nav">
          <Nav className="ms-auto navbar-links">
            <Nav.Link href="/home">Home</Nav.Link>
            <Nav.Link href="/screening_program">Screening Programs</Nav.Link>
            <Nav.Link href="/partner_us">Partner with Us</Nav.Link>
            <Nav.Link href="/about_us">About Us</Nav.Link>
            <Nav.Link href="/locations">Locations</Nav.Link>
            <Nav.Link href="/contact">Contact</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavBar;
